export function integrationsPreview() {
    const preview = document.querySelector('.integrations .preview-inner');
    if (!!preview === false) return;
    const orbits = [];
    preview.querySelectorAll('.orbit').forEach((orbit) => {
        const speedAttr = orbit.getAttribute('data-speed');
        const obj = {
            el: orbit,
            speed: speedAttr ? +speedAttr : 10000,
            direction: orbit.getAttribute('data-clockwise') === 'true' ? 0 : 1,
            rotation: 0,
            items: [],
        };
        orbit.querySelectorAll('.item').forEach((item) => {
            const sizeString = item.getAttribute('data-size');
            const orbitMultiplier = preview.clientWidth / orbit.clientWidth;
            if (sizeString) item.style.setProperty('--width', parseFloat(sizeString) * orbitMultiplier + '%');
            obj.items.push({
                el: item,
            });
        });
        orbits.push(obj);
    });

    // place items
    orbits.forEach((orbit) => {
        orbit.items.forEach((item) => {
            const posDegreesString = item.el.getAttribute('data-pos-deg');
            if (!!posDegreesString === false) return;
            const posDegrees = +posDegreesString;
            if (posDegrees === 0) return;
            const posRad = posDegrees * (Math.PI / 180);
            const left = 0 - -50 * Math.sin(posRad) + 50;
            const top = 0 + -50 * Math.cos(posRad) + 50;
            item.el.style.setProperty('left', left + '%');
            item.el.style.setProperty('top', top + '%');
            item.el.style.setProperty('display', 'block');
        });
    });

    // animation
    function rotateOrbits(deltaTime) {
        orbits.forEach((orbit) => {
            orbit.rotation = ((360 / orbit.speed) * deltaTime + orbit.rotation) % 360;
            orbit.el.style.transform = `rotate(${orbit.direction ? '-' : ''}${orbit.rotation}deg)`;
            rotateItems(orbit);
        });
    }
    function rotateItems(orbit) {
        orbit.items.forEach((item) => {
            item.el.style.transform = `translate(-50%, -50%) rotate(${orbit.direction ? '' : '-'}${orbit.rotation}deg)`;
        });
    }
    let lastFrameTimestamp = 0;
    function update(timestamp) {
        const deltaTime = timestamp - lastFrameTimestamp;
        rotateOrbits(deltaTime);
        lastFrameTimestamp = timestamp;
        requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
}
